module.exports = "/images/merchant-placeholder-img.jpg";